import React from "react";
import { Organization } from "@/types/utils";
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { Styled } from "../../components/organizations/styles";
import { Button, UncontrolledInput } from "@dippi/ui";
import OrganizationModal from "./widgets/modal";
import SearchIcon from "@mui/icons-material/Search";
import { useOrganizationsList } from "./hooks";
import { SELECT_ITEMS } from "@/utils/helpers";
import DeleteIcon from "@mui/icons-material/Delete";

interface Props {
    data: Organization[] | undefined;
}

const OrganizationsList: React.FC<Props> = ({ data }) => {
    const {
        organizations,
        modal,
        openModal,
        closeModal,
        onSelect,
        onSearch,
        onCountrySelect,
        onSubscriptionPlanSelect,
        filteredCountry,
        filteredPlan,
        clearFilters,
        searchValue,
    } = useOrganizationsList(data);

    const countries = SELECT_ITEMS.countries;
    const subscriptionPlans = SELECT_ITEMS.subscriptionPlans;

    return (
        <Styled.Container>
            <Styled.Header>
                <Box textAlign="center">
                    <Typography marginBottom={0} variant="h1">
                        Organizations
                    </Typography>
                </Box>
                <Box width="100%" display="flex" gap={2} alignItems="center" marginLeft="auto">
                    <Box flexBasis="50%">
                        <UncontrolledInput
                            size="small"
                            placeholder="Search"
                            onChange={onSearch}
                            value={searchValue}
                            InputProps={{
                                endAdornment: <SearchIcon sx={{ width: "18px" }} />,
                            }}
                        />
                    </Box>
                    <Box display="flex" gap={2} flex="50%" position="relative">
                        <FormControl size="small" fullWidth>
                            <InputLabel>Country</InputLabel>
                            <Select
                                label="Country"
                                value={filteredCountry}
                                onChange={onCountrySelect}
                            >
                                {countries.map(i => (
                                    <MenuItem key={i.value} value={i.value}>
                                        {i.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl size="small" fullWidth>
                            <InputLabel>Plan</InputLabel>
                            <Select
                                label="Plan"
                                value={filteredPlan}
                                onChange={onSubscriptionPlanSelect}
                            >
                                {subscriptionPlans.map(i => (
                                    <MenuItem key={i.value} value={i.value}>
                                        {i.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {(searchValue || filteredCountry || filteredPlan) && (
                            <Styled.ClearBtn
                                variant="text"
                                onClick={clearFilters}
                                title="Clear filters"
                            >
                                <DeleteIcon />
                            </Styled.ClearBtn>
                        )}
                    </Box>
                </Box>
            </Styled.Header>
            {Array.isArray(organizations) ? (
                <Styled.List>
                    {organizations.map(i => {
                        return (
                            <Styled.ListItem key={i._id} onClick={onSelect.bind(this, i._id)}>
                                <Typography variant="h4">{i.title}</Typography>
                                <Typography variant="body2">{i.companyId}</Typography>
                            </Styled.ListItem>
                        );
                    })}
                </Styled.List>
            ) : null}
            <Button sx={{ width: "100%", padding: "25px 0px" }} onClick={openModal}>
                Add new organization
            </Button>
            <OrganizationModal modal={modal} closeModal={closeModal} />
        </Styled.Container>
    );
};

export default OrganizationsList;
